export type ContentType = "image" | "link" | "note";
export type MenuItemKey = "photo" | "images" | "link" | "collection";

export interface AddMenuItem {
  key: MenuItemKey;
  label: string;
}

export const ADD_MENU_ITEMS: AddMenuItem[] = [
  { key: "collection", label: "Collection" },
  { key: "photo", label: "Photo" },
  { key: "images", label: "Image" },
  { key: "link", label: "Link" },
];

export type MenuSelectionAction =
  | { type: "create-collection" }
  | { type: "open-modal"; contentType: ContentType }
  | { type: "native-pick"; source: "camera" | "library" };

export const resolveMenuSelection = (
  key: MenuItemKey,
  isNative: boolean,
): MenuSelectionAction => {
  if (key === "collection") return { type: "create-collection" };
  if (key === "link") return { type: "open-modal", contentType: "link" };
  if (isNative) return { type: "native-pick", source: key === "photo" ? "camera" : "library" };
  return { type: "open-modal", contentType: "image" };
};
